import { render, staticRenderFns } from "./ConsultarFolioPantalla.vue?vue&type=template&id=bda8c66c&"
import script from "./ConsultarFolioPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConsultarFolioPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bda8c66c', component.options)
    } else {
      api.reload('bda8c66c', component.options)
    }
    module.hot.accept("./ConsultarFolioPantalla.vue?vue&type=template&id=bda8c66c&", function () {
      api.rerender('bda8c66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConsultarFolio/ConsultarFolioPantalla.vue"
export default component.exports